export const DEFAULT_PRODUCT_IMAGE = "linear-gradient(135deg, #efe0cc 0%, #9d724d 100%)"

export const GOODS_TYPE = {
  SOFTWARE: 1,
  PHYSICAL: 2,
  COUPON: 3,
}

/** 积分中心 / 积分商城成功码仅认字符串 "200" */
export function isPointsApiSuccess(res) {
  return Boolean(res) && res.code === "200"
}

export function parsePointValue(value) {
  const number = Number(String(value ?? "").replace(/,/g, ""))
  return Number.isFinite(number) ? number : 0
}

export function formatPoints(value) {
  const number = parsePointValue(value)
  if (!Number.isFinite(number)) {
    return value
  }

  const integerPart = String(Math.trunc(Math.abs(number)))
  if (integerPart.length > 6) {
    return `${Number(integerPart.slice(0, 6)).toLocaleString("en-US")}...`
  }

  return number.toLocaleString("en-US")
}

export function getProductDetails(item) {
  const detailList = item && Array.isArray(item.detailList) ? item.detailList : []
  return [...detailList].sort((prev, next) => {
    return parsePointValue(prev.sortOrder) - parsePointValue(next.sortOrder)
  })
}

export function getPrimaryGoodsDetail(item) {
  return getProductDetails(item)[0] || {}
}

export function getGoodsType(item) {
  return Number(item?.goodsType || 0)
}

export function isPhysicalGoods(item) {
  return getGoodsType(item) === GOODS_TYPE.PHYSICAL
}

export function isSoftwareGoods(item) {
  return getGoodsType(item) === GOODS_TYPE.SOFTWARE
}

export function isCouponGoods(item) {
  return getGoodsType(item) === GOODS_TYPE.COUPON
}

/**
 * 读取规格库存，实物 / 软件码 / 优惠券都只认 availableStock。
 * @returns {number|null} 字段为 null、undefined、空字符串时返回 null
 */
function readDetailStock(detail) {
  const raw = detail?.availableStock
  if (raw === null || raw === undefined || raw === "") {
    return null
  }
  return parsePointValue(raw)
}

export function getAvailableStock(item) {
  const details = getProductDetails(item)
  if (!details.length) {
    return null
  }

  let hasValue = false
  const total = details.reduce((sum, detail) => {
    const value = readDetailStock(detail)
    if (value === null) {
      return sum
    }
    hasValue = true
    return sum + value
  }, 0)

  return hasValue ? total : null
}

/** 无 availableStock 或库存 <= 0 视为补货中，列表/详情都显示 Restocking */
export function isProductOutOfStock(item) {
  const stock = getAvailableStock(item)
  return stock === null || stock <= 0
}

/** 是否可在当前站点兑换，只认 canPurchase === true */
export function canPurchaseAtSite(item) {
  return item?.canPurchase === true
}

export function getProductPoints(item) {
  return getPrimaryGoodsDetail(item).pointsPrice || 0
}

export function getProductTitle(item) {
  return item?.title || "-"
}

export function getProductDescription(item) {
  return item?.description || ""
}

/** 实物且后台录入了规格时拼接 detailName，非实物返回空以隐藏整行 */
export function getSpecText(item) {
  if (!isPhysicalGoods(item)) {
    return ""
  }

  return getProductDetails(item)
    .map((detail) => detail.detailName || "")
    .filter(Boolean)
    .join(" / ")
}

/** 实物发货说明只认 deliveryNote，无内容则隐藏整行 */
export function getDeliveryNote(item) {
  if (!isPhysicalGoods(item)) {
    return ""
  }
  const note = item && item.deliveryNote
  if (note === undefined || note === null || note === "") {
    return ""
  }
  return String(note).trim()
}

export function getCoverUrl(item) {
  const url = item?.coverUrl || ""
  if (!url || url.indexOf("gradient") !== -1) {
    return ""
  }
  return url
}

/** 商品封面加 OSS 缩略参数，空封面返回空字符串交给占位图 */
export function getCoverThumbUrl(item) {
  const url = getCoverUrl(item)
  if (!url) {
    return ""
  }
  return url.indexOf("?") === -1
    ? `${url}?x-oss-process=image/resize,p_40`
    : `${url}&x-oss-process=image/resize,p_40`
}

export function normalizeMallGoodsList(list) {
  return (Array.isArray(list) ? list : []).map((item) => ({
    ...item,
    detailList: Array.isArray(item?.detailList) ? item.detailList : [],
  }))
}
